import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter }) {
  const [title, setTitle] = useState(""); // useState hook
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [newInst, setNewInst] = useState({
    title: "",
    address: "",
    email: "",
    tel1: "",
    tel2: "",
    fax: "",
    contact_name: "",
  });

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (name === "active") {
      setNewInst((prevState) => ({
        ...prevState,
        active: e.target.checked,
      }));
    } else
      setNewInst((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/evaluationinstitute/",
          newInst,
          {
            signal: controller.signal,
          }
        );
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2> מכון מיון</h2>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="title">שם המכון </label>
                        <input
                          type="text"
                          name="title"
                          value={newInst.title}
                          onChange={handleChange}
                          className="form-control"
                          id="title"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="contact_name">שם איש קשר</label>
                        <input
                          type="text"
                          name="contact_name"
                          value={newInst.contact_name}
                          onChange={handleChange}
                          className="form-control"
                          id="contact_name"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col style={{ minWidth: "500px" }}>
                      <div className="form-group">
                        <label htmlFor="address">כתובת</label>
                        <input
                          type="text"
                          name="address"
                          value={newInst.address}
                          onChange={handleChange}
                          className="form-control"
                          id="address"
                        />
                      </div>
                    </Col>
                  </Row>{" "}
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="tel1">מס טלפון 1</label>
                        <input
                          type="text"
                          name="tel1"
                          value={newInst.tel1}
                          onChange={handleChange}
                          className="form-control"
                          id="tel1"
                        />
                      </div>
                    </Col>

                    <Col>
                      <div className="form-group">
                        <label htmlFor="tel2">מס טלפון 2</label>
                        <input
                          type="text"
                          name="tel2"
                          value={newInst.tel2}
                          onChange={handleChange}
                          className="form-control"
                          id="tel2"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="fax">מס פקס </label>
                        <input
                          type="text"
                          name="fax"
                          value={newInst.fax}
                          onChange={handleChange}
                          className="form-control"
                          id="fax"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="fax">דואר אלקטרוני</label>
                        <input
                          type="email"
                          name="email"
                          value={newInst.email}
                          onChange={handleChange}
                          className="form-control"
                          id="email"
                        />
                      </div>
                    </Col>
                  </Row>{" "}
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף מכון מיון חדש
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="מכון המיון נוסף בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
